export default () => ({
  swiper: null,
  isMobile: null,

  init() {
    this.setIsMobile();
  },

  setIsMobile() {
    this.isMobile = window.innerWidth < 1024 ? true : false;
  },
});
